import type { Ref } from "react";
import { Avatar, type AvatarSize } from "@design-system/Avatar/Avatar";

export interface ConsolidatedAvatarProps {
    /** The consolidation group's name; the avatar shows its initial. */
    name: string;
    size?: AvatarSize;
    className?: string;
    /** Set when the group's name is visible next to the avatar. */
    "aria-hidden"?: boolean;
    ref?: Ref<HTMLSpanElement>;
}

/** A consolidation group as an outlined square with its initial. */
export const ConsolidatedAvatar = ({
    name,
    size,
    className,
    "aria-hidden": isAriaHidden,
    ref,
}: Readonly<ConsolidatedAvatarProps>) => (
    <Avatar
        ref={ref}
        name={name}
        shape="square"
        variant="outline"
        tone="neutral"
        size={size}
        className={className}
        aria-hidden={isAriaHidden}
    />
);
